export const MIN_SELF_BUDGET_LOAD = 500;
